import React from 'react';

function EmptyPlaceholder() {
    return <div>Loading...</div>;
}

export default EmptyPlaceholder;
